// extracted by mini-css-extract-plugin
module.exports = {"root":"IconReviewStar_root__3YeZ9","filled":"IconReviewStar_filled__1iuZ-"};